import React, { useState } from "react"
import { Button, Alert } from "../../../../../components"
import { FormSelect, FormRadioGroup, FormHiddenInput } from "../../../../../features/auto-form"
import { FormHiddenDeparturePicker, FormHiddenDestinationSelector, FormHiddenCalendar } from "../../../../../modules/custom-form-modules"
//import { useTranslate } from "../../../features/translation/hooks/use-translation";
import { useFormContext } from "../../../../../features/auto-form"
import SE_DEPARTURE_AIRPORTS from "../data/se-departure-airports.json"
import PACKAGE_DESTINATIONS from "../data/package-destinations.json"
import FO_FLEXIBILITY_OPTIONS from "../data/fo-flexibility-options.json"


const FlightOnlySearch = () => {
    const [disableHomeboundInput, setDisableHomeboundInput] = useState(false);
    const [earliestCheckoutDate, setEarliestCheckoutDate] = useState(null)


    const { resetRefValue } = useFormContext()

    const reset = () => {
        resetRefValue("product.flightOnly.flightType")
        resetRefValue("product.flightOnly.departureAirport")
        resetRefValue("product.flightOnly.destinationAirport")
        resetRefValue("product.flightOnly.departureDate")  
        resetRefValue("product.flightOnly.homeboundDate")
        resetRefValue("product.fligthOnly.dateFlexibility")
        setDisableHomeboundInput(false)
        setEarliestCheckoutDate(null)

    }

    const handleCheckinChange = (e) => {
        const { value } = e.target
        if (value) {
            const date = new Date(value)
            date.setDate(date.getDate() + 1)
            setEarliestCheckoutDate(date)
          //  setDisableCheckout(false)
        }
    }

    const handleFlightTypeChange = (e) => {
        const {value} = e.target

        if (value === "oneway"){
            setDisableHomeboundInput(true)
            resetRefValue("product.flightOnly.homeboundDate")
        }
        else if (value === "return") {
            setDisableHomeboundInput(false)
        }
    }



    return (
        <div className="container" style={{padding:"0", margin:"0"}}>
            <FormHiddenInput 
                name="request.product.type"
                value="flightOnly"
            />
            <div className='row'>
                <div className='col col-12'>
                    <Alert
                        type="info"
                    >
                        <div className='text base' dangerouslySetInnerHTML={{ __html: "At the moment we have a limit capability of flight only bookings. We are working on expanding this service. " }} />
                    </Alert>
                </div>
            </div>
            <div className='row'>
                <div className='col col-12'>
                    <FormRadioGroup
                        name="product.flightOnly.flightType"
                        className="horizontal"
                        onChange={(e) =>  handleFlightTypeChange(e) }
                        defaultValue="return"
                        disabled={true}
                        options={[
                            { label: "Return flight", value: "return" },
                            { label: "One-way flight", value: "oneway" }
                        ]}

                    />
                </div>
            </div>
            <div className='row'>
                <div className='col col-12 col-sm-6 col-md-3'>
                    <FormHiddenDeparturePicker
                        name="product.flightOnly.departureAirport"
                        label="From"
                        market="se" // SHould be from form context as hidden input
                        icon="aircraft-up"
                        disabled={true}

                        placeholder="Choose departure airport"
                        options={SE_DEPARTURE_AIRPORTS}
                    />
                </div>
                <div className='col col-12 col-sm-6 col-md-3'>
                    <FormHiddenDestinationSelector
                        name="product.flightOnly.destinationAirport"
                        market="se"
                        label="Where"
                        icon="map"
                        disabled={true}
                        placeholder="Choose departure airport"
                        options={PACKAGE_DESTINATIONS}
                    />
                </div>

                <div className='col col-12 col-sm-6 col-md-2'>
                    <FormHiddenCalendar
                        name="product.flightOnly.departureDate"
                        label="Departure"
                        icon="aircraft-up"
                        disabled={true}

                        onChange={handleCheckinChange}
                        placeholder="Select departure date"
                        required
                    />
                </div>
                <div className='col col-12 col-sm-6 col-md-2'>
                <FormHiddenCalendar
                        name="product.flightOnly.homeboundDate"
                        label="Homebound"
                        icon="aircraft-down"
                        placeholder="Select homebound date"
                        min={earliestCheckoutDate }
                        disabled={disableHomeboundInput}
                        required
                    />
                </div>
                <div className='col col-12 col-sm-6 col-md-2' style={{ display: "flex", alignItems: "flex-end" }}>
                    <FormSelect
                        name="product.fligthOnly.dateFlexibility"
                        placeholder="Select flexibility"
                        label="Flexibility"
                        disabled={true}
                        options={FO_FLEXIBILITY_OPTIONS}
                    />
                </div>
            </div>
            <div className='row'>
                <div className='col col-12' style={{ display: "flex", justifyContent: "end" }}>
                    <Button
                        label={"Reset fields"}
                        className="ghost medium"
                        style={{ border: 0, textDecoration: "underline" }}
                        onClick={reset}
                    />
                </div>

            </div>
        </div>
    )
}

export default FlightOnlySearch;